import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safeHtml', standalone: true })
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}

  transform(value: any): any {
    if (value) {
      // If we don't unescape quotes, embedded css won't work
      value = value.replace(/\\\"/g, '"');
    }
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}
